import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppAttributesService } from "src/app/services/app-attributes.service";
import * as moment from 'moment';
import { ArService } from './../../services/ar.service';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})

export class FiltersComponent implements OnInit {
  @Input() service: (payload?: any) => void;
  @Input() disabledFilters: string[] = [];
  filtersForm: FormGroup;
  contracts = [];
  stations = [];
  reservationStatusList = [
    { resStatusId: "A", resCustText: "Concierge Assigned", resBoText: "Assigned" },
    { resStatusId: "C", resCustText: "Completed Service", resBoText: "Completed" },
    { resStatusId: "E", resCustText: "Error with Credit Card", resBoText: "Error CC" },
    { resStatusId: "I", resCustText: "Greet In Process", resBoText: "In Progress" },
    { resStatusId: "P", resCustText: "Pending Credit Card Details", resBoText: "Pending CC" },
    { resStatusId: "R", resCustText: "Canceled without Charges", resBoText: "Canx No Charge" },
    { resStatusId: "U", resCustText: "Confirmed Booking", resBoText: "Unassigned" },
    { resStatusId: "W", resCustText: "Wait Listed not Confirmed", resBoText: "Wait Listed" },
    { resStatusId: "X", resCustText: "Canceled with Charges", resBoText: "Canx Charge" }
  ];
  completionStatusList = [
    { label: 'Completed', value: 'Completed' },
    { label: 'Complete', value: 'Complete' },
    { label: 'Reviewed', value: 'Reviewed' },
    { label: 'Needs Review', value: 'Needs Review' },
    { label: 'Unfulfilled Reviewed', value: 'Unfulfilled Reviewed' },
    { label: 'Unfulfilled Service', value: 'Unfulfilled Service' },
    { label: 'No Status', value: 'No Status' }
  ];
  customerList: []
  yesNoOptions = [
    { label: 'Capital one', value: true },
  ];

  constructor(
      private fb: FormBuilder,
      private appAttrService : AppAttributesService,
      public arService: ArService
  ) { }

  ngOnInit(): void {
    this.getAppAttributes()
    this.filtersForm = this.fb.group({
      resType: [[]],
      resStatus: [[]],
      startDate: [''],
      endDate: [''],
      stationCodes: [[]],
      companyName: [[]],
      isCapitalOne: [[]]
    });
    this.applyDisabledFilters()
  }
  private applyDisabledFilters() {
    this.disabledFilters.forEach(field => {
      const control = this.filtersForm.get(field);
      if (control) {
        control.disable();
      }
    });
  }
  onSearch() {
    const filters = { ...this.filtersForm.value };

    if (filters.startDate) {
      filters.startDate = moment(filters.startDate).format('YYYY-MM-DD');
    }

    if (filters.endDate) {
      filters.endDate = moment(filters.endDate).format('YYYY-MM-DD');
    }

    this.service(filters);
  }

  onClear() {
    this.filtersForm.reset({
      resType: [],
      resStatus: [],
      startDate: '',
      endDate: '',
      stationCodes: [],
      companyName: [],
      isCapitalOne: []
    });
    this.service()
  }
  getAppAttributes() {
    this.contracts = this.appAttrService.getContractsWithRetail();
    this.stations = this.appAttrService.getAppAttributes().stations;
    if(!this.disabledFilters.includes('companyName')) {
      this.getCustomers()
    }
  }
  getCustomers() {
    this.arService.getCustomers().subscribe((customersData) => {
      this.customerList = customersData['result']
    })
  }
}
